<template>
  <svg ref="barcode"></svg>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import JsBarcode from "jsbarcode";

export default defineComponent({
  name: "BarcodeGenerator",
  props: {
    value: {
      type: String,
      required: true,
    },
    format: {
      type: String,
      default: "CODE128",
    },
    width: {
      type: Number,
      default: 2,
    },
    height: {
      type: Number,
      default: 100,
    },
    displayValue: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const barcode = ref<SVGSVGElement | null>(null);

    const generateBarcode = () => {
      if (barcode.value) {
        try {
          JsBarcode(barcode.value, props.value, {
            format: props.format,
            width: props.width,
            height: props.height,
            displayValue: props.displayValue,
          });
        } catch (error) {
          // Clear SVG if invalid so it doesn't show old text/barcode
          barcode.value.innerHTML = ''; 
          console.warn(`Invalid barcode value "${props.value}" for format ${props.format}. Waiting for valid input.`);
        }
      }
    };

    onMounted(generateBarcode);

    watch(() => props.value, generateBarcode);
    watch(() => props.format, generateBarcode);

    return {
      barcode,
    };
  },
});
</script>
